import classNames from 'classnames';
import React from 'react';

interface SimpleDivTableLastCellProps {
  children: React.ReactNode;
  actionButtons?: JSX.Element;
  cellClassName?: string;
  contentsClassName?: string;
}

/**
 * Wrapper component for the last cell in a SimpleDivTable row.
 * When actionButtons are provided, renders them inside the cell with flex layout
 * When actionButtons are not provided, uses standard padding to reserve space
 * for absolutely positioned action buttons.
 */
export default function SimpleDivTableLastCell({
  children,
  actionButtons,
  cellClassName,
  contentsClassName,
}: SimpleDivTableLastCellProps): JSX.Element {
  const hasCompactActions = Boolean(actionButtons);

  return (
    <div
      className={classNames(
        'simpleDivTable-cell',
        hasCompactActions && 'simpleDivTable-cell--lastWithCompactActions',
        cellClassName
      )}
    >
      <div className={classNames('simpleDivTable-cell-contents', contentsClassName)}>{children}</div>
      {actionButtons && (
        <div className="simpleDivTable-actionGroupContainer simpleDivTable-actionGroupContainer--compact">
          {actionButtons}
        </div>
      )}
    </div>
  );
}
